import React from "react";
import styles from "./ToggleSwitch.module.css";

const ToggleSwitch = ({ checked, onChange, label, variant = "default" }) => {
	return (
		<label className={styles.toggleSwitch}>
			<input
				type="checkbox"
				checked={checked}
				onChange={onChange}
				className={styles.input}
			/>
			<span className={`${styles.slider} ${styles[variant]}`} />
			{label && <span className={styles.label}>{label}</span>}
		</label>
	);
};

export default ToggleSwitch;
